<template>
  <span>
    <v-icon v-if="ready" :color="statusIconData.color">{{ statusIconData.icon }}</v-icon>
  </span>
</template>

<script>
export default {
  props: {
    entity: {
      type: String,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      ready: false,
      statusIconData: { icon: 'help-circle-outline', color: 'grey', text: '' },
    };
  },
  mounted() {
    this.statusIconData = this.getIcon();
    this.ready = true;
  },
  methods: {
    getIcon() {
      return this[this.entity + 'GetStatusIcon']();
    },

    calendarEventGetStatusIcon() {
      switch (this.status) {
        case 'confirmed':
          return { icon: 'mdi-calendar-check-outline', color: 'primary' };
        default:
          return { icon: 'mdi-clock-outline', color: 'grey' };
      }
    },
  },
};
</script>

<style></style>
